module.exports = __webpack_public_path__ + "static/media/symbols.ab42743e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/custom-sprite/svg/symbols.svg
// module id = 470
// module chunks = 0